import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { OrganisationService } from './organisation.service';

/**
 * Guard that checks if labs feature is enabled for the current organization
 * @returns A promise that resolves to true if labs are enabled, false otherwise
 */
export const labsGuard: CanActivateFn = async (
) => {
  const organisationService = inject(OrganisationService);
  return organisationService.currentOrganisation()?.enabledLabs ?? false;
};
